import { Action } from '@ngrx/store';
import { CashFlowRequest, Periods, CashFlow, CashFlowFilter } from './cash-flow.models';
import { DatesIntervalRequest, DatesInterval } from '../../global/interfaces';
import { LoadDataRequest, SortInfo } from '../../global/interfaces';


export enum ActionTypes {
  LOAD_CASH_DATES              = '[Cash Flow] Load Cash Flow Dates Action',
  LOAD_CASH_DATES_SUCCESS      = '[Cash Flow] Load Cash Flow Dates Success Action',
  LOAD_CASH_DATES_FAILED       = '[Cash Flow] Load Cash Flow Dates Failed Action',

  LOAD_CASH_DATA               = '[Cash Flow] Load Cash Flow Data Action',
  LOAD_CASH_DATA_SUCCESS       = '[Cash Flow] Load Cash Flow Data Success Action',
  LOAD_CASH_DATA_FAILED        = '[Cash Flow] Load Cash Flow Data Failed Action',

  SET_CASH_FLOW_PERIOD_FILTER  = '[Cash Flow] Set Cash Flow Period Filter Action',
  SET_CASH_FLOW_YEAR_FILTER    = '[Cash Flow] Set Cash Flow Year Filter Action',
  SET_CASH_FLOW_MONTH_FILTER   = '[Cash Flow] Set Cash Flow Month Filter Action',
  SET_CASH_FLOW_QUARTER_FILTER = '[Cash Flow] Set Cash Flow Quarter Filter Action',
  SET_CASH_FLOW_SORT              = '[Cash Flow] Set Cash Flow Sort Action',

  CASH_FLOW_FILE_DOWNLOAD      = '[Cash Flow] Cash Flow File Download Action',

  RESET_CASH_FLOW_DATA         = '[Cash Flow] Reset Cash Flow Data Action',
  RESET_CASH_FLOW_DATA_RECORDS = '[Cash Flow] Reset Cash Flow Data Records Action'
}

export class LoadCashDatesAction implements Action {
  readonly type = ActionTypes.LOAD_CASH_DATES;

  public constructor(public payload: DatesIntervalRequest) {
  }
}

export class LoadCashDatesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_CASH_DATES_SUCCESS;

  public constructor(public payload: DatesInterval) {
  }
}

export class LoadCashDatesFailedAction implements Action {
  readonly type = ActionTypes.LOAD_CASH_DATES_FAILED;

  public constructor(public payload: any) {
  }
}

export class LoadCashDataAction implements Action {
  readonly type = ActionTypes.LOAD_CASH_DATA;

  public constructor(public payload: CashFlowRequest) {
  }
}

export class LoadCashDataSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_CASH_DATA_SUCCESS;

  public constructor(public payload: CashFlow[]) {
  }
}

export class LoadCashDataFailedAction implements Action {
  readonly type = ActionTypes.LOAD_CASH_DATA_FAILED;

  public constructor(public payload: any) {
  }
}

export class SetCashFlowPeriodFilterAction implements Action {
  readonly type = ActionTypes.SET_CASH_FLOW_PERIOD_FILTER;

  public constructor(public payload: Periods) {
  }
}

export class SetCashFlowYearFilterAction implements Action {
  readonly type = ActionTypes.SET_CASH_FLOW_YEAR_FILTER;

  public constructor(public payload: number) {
  }
}

export class SetCashFlowMonthFilterAction implements Action {
  readonly type = ActionTypes.SET_CASH_FLOW_MONTH_FILTER;

  public constructor(public payload: number) {
  }
}

export class SetCashFlowQuarterFilterAction implements Action {
  readonly type = ActionTypes.SET_CASH_FLOW_QUARTER_FILTER;

  public constructor(public payload: number) {
  }
}

export class CashFlowFileDownloadAction implements Action {
  readonly type = ActionTypes.CASH_FLOW_FILE_DOWNLOAD;

  public constructor(public payload: CashFlowRequest) {
  }
}

export class ResetCashFlowDataAction implements Action {
  readonly type = ActionTypes.RESET_CASH_FLOW_DATA;

}
export class SetCashFlowSortAction implements Action {
  readonly type = ActionTypes.SET_CASH_FLOW_SORT;

  public constructor(public payload: SortInfo) {
  }
}

export class ResetCashFlowDataRecordsAction implements Action {
  readonly type = ActionTypes.RESET_CASH_FLOW_DATA_RECORDS;
}

export type Actions =
  LoadCashDatesAction |
  LoadCashDatesSuccessAction |
  LoadCashDatesFailedAction |
  LoadCashDataAction |
  LoadCashDataSuccessAction |
  LoadCashDataFailedAction |
  SetCashFlowPeriodFilterAction |
  SetCashFlowYearFilterAction |
  SetCashFlowMonthFilterAction |
  SetCashFlowQuarterFilterAction |
  CashFlowFileDownloadAction |
  ResetCashFlowDataAction |
  SetCashFlowSortAction |
  ResetCashFlowDataRecordsAction;
